import { ThirdPartySampleProviderEnum } from './third-party-provider.enum';

export class ThirdPartySampleProvider {
  providerType: ThirdPartySampleProviderEnum;
  qualifiedUrl: string;
  terminatedUrl: string;
  quotaFullUrl: string;
}
